const CaretIcon = () => (
  <svg
    width='8'
    height='12'
    viewBox='0 0 8 12'
    fill='none'
    aria-hidden='true'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.552733 12C0.734551 12 0.850907 11.9099 0.989083 11.8086L7.32362 7.40712C7.70181 7.13697 8 6.68667 8 6.02252C8 5.38087 7.70908 4.91932 7.33091 4.64915L0.989083 0.168873C0.858175 0.067549 0.749088 0 0.581822 0C0.240007 0 0 0.371498 0 0.900574C0 1.37337 0.159994 1.63227 0.429094 1.82365L6.46545 5.8987V6L0.429094 10.1651C0.159994 10.3565 0 10.6154 0 11.0882C0 11.6398 0.232724 12 0.552733 12Z'
      fill='currentColor' />
  </svg>
)

export default CaretIcon